import React from "react";
import "../../styles/OperationalDiagnostic.css";
import { ArrowRight } from 'lucide-react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import ComparisonTable from "./ComparisonTable";

const OperationalDiagnostic = () => {
  return (
    <section className="diagnostic-sectio">
      {/* <h4 className="diagnostic-intro">Operational Diagnostic for Food &Beverage Businesses</h4> */}
      <div className="diagnostic-containe">
        <h4 className="philosophy-tag">Operational Diagnostic for Food &Beverage Businesses</h4>
        <h2 className="title-tag"><b>Every Engagement Begins With Clarity</b></h2>

        <p className="diagnostic-intr">
          Before we build or implement anything, we map how your business actually runs — not how it appears on paper.
        </p>

        <h4 className="title-tag">
          You receive:
        </h4>
        <ComparisonTable />
        
        {/* <section className="feature-benefit-section">
  <div className="fb-container">
    <h2 className="fb-title">
      Feature vs. Benefit Translation for FNBDATALAB
    </h2> */}

    {/* <div className="fb-table">

      <div className="fb-row fb-header">
        <div className="fb-col feature">WHAT WE DO (Feature)</div>
        <div className="fb-col benefit">WHAT YOU GET (Benefit)</div>
      </div>

      <div className="fb-row">
        <div className="fb-col feature">Operational Diagnostic</div>
        <div className="fb-col benefit">
          You finally know exactly where your money is leaking — and how to stop it.
        </div>
      </div>

      <div className="fb-row">
        <div className="fb-col feature">SOP & Workflow Systems</div>
        <div className="fb-col benefit">
          Your team stops depending on you. Weekends become yours again.
        </div>
      </div>

      <div className="fb-row">
        <div className="fb-col feature">Cost & Margin Visibility</div>
        <div className="fb-col benefit">
          You stop being surprised at month-end. Profitability becomes predictable.
        </div>
      </div>

      <div className="fb-row">
        <div className="fb-col feature">POS & Reporting Alignment</div>
        <div className="fb-col benefit">
          Your data tells you the truth, not what you hope to see.
        </div>
      </div>

      <div className="fb-row">
        <div className="fb-col feature">Growth Infrastructure</div>
        <div className="fb-col benefit">
          You open a second location without breaking what already works.
        </div>
      </div>

    </div>
  </div>
  
</section> */}
<div className="diagnostic-containe">
<p className="diagnostic-intr"><b >We build operating systems for restaurants that want to scale without chaos.</b></p></div>








        {/* <div className="values-grid">
          <div className="value-card">
            <ul className="diagnostic-list arrows">
          <li>Margin and cost leak visibility</li>
          <li>Workflow breakdown insights</li>
          <li>POS and reporting evaluation</li>
          <li>A clear, prioritised action roadmap</li> */}
          {/* <li>Identify execution and workflow gaps</li>
          <li>Assess data, POS, and reporting integrity</li> */}
        {/* </ul>
          </div>
          </div> */}

        {/* <ul className="diagnostic-list arrows">
          <li>Expose cost and margin leaks</li>
          <li>Identify execution and workflow gaps</li>
          <li>Assess data, POS, and reporting integrity</li>
        </ul> */}

        {/* <h4 className="diagnostic-subtitle">Outcome:</h4>
        <div className="values-grid">
          <div className="value-card">
            <ul className="diagnostic-list checks">
          <li>Clear problem map</li>
          <li>Priority actions</li>
          <li>Decision confidence</li>
        </ul>
          </div>
          </div> */}                            

        {/* <ul className="diagnostic-list checks">
          <li>Clear problem map</li>
          <li>Priority actions</li>
          <li>Decision confidence</li>
        </ul> */}

        <div className="diagnostic-cta">
          <div className="diagnostic-fee">
            <strong>Investment: ₹15,000 – ₹20,000</strong>
            <span>(Based on business size and complexity)</span>
          </div>
          <div className="value-card">
            <div className="highligh">

          {/* <p className="diagnostic-intro"> */}
            <b>
          We turn guesswork into systems. Chaos into margin. Busyness into growth</b>
          {/* </p> */}
          </div>
          </div>
          

          <button className="diagnostic-btn">
           < Link to="/operationals-diagnostic">
          Book the Operational Diagnostic
        </Link>
            {/* <a href="#operational-diagnostic" className="btn-primary">
            Book the Operational Diagnostic
            <ArrowRight size={20} />
          </a> */}
            {/* Book the Operational Diagnostic */}
          </button>
        </div>
      </div>
    </section>
  );
};

export default OperationalDiagnostic;